import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Heatmap from "../../views/Heatmap";
import { actionCreators } from "./redux/sagas/heatmap";
import SecondaryCategory from "./smartComponents/secondaryCategory";
import { useSelector, useDispatch } from "react-redux";
import "./HeatmapModule.css";

const HeatmapModule = (props) => {
  const dispatch = useDispatch();
  const { fetchHeatmapData, fetchCurrentUser } = actionCreators;

  const { useSecondaryCategories, sourceType } = props.params;
  const { filtersDirty, isLoading } = useSelector((state) => state);

  useEffect(() => {
    dispatch(fetchCurrentUser(props.params));
  }, []);

  const renderUpdateBtn = () => {
    if (filtersDirty && !isLoading) {
      return (
        <button
          className="submit override-submit"
          onClick={() => dispatch(actionCreators.updateHeatmapData())}
        >
          Update
        </button>
      );
    }
  };

  const renderResetBtn = () => {
    if (filtersDirty && !isLoading) {
      return (
        <button
          className="submit reset override-submit"
          onClick={() => dispatch(actionCreators.resetFilters())}
        >
          Reset
        </button>
      );
    }
  };

  return (
    <div>
      {sourceType === "clubready" ? (
        <div id="heatmap-edit-selection-bar" className="edit-selections-bar">
          <div className="select-box-no-width">
            <p>{useSecondaryCategories ? "Secondary Category" : "Category"}</p>
            <SecondaryCategory />
          </div>
          {renderUpdateBtn()}
          {renderResetBtn()}
        </div>
      ) : null}

      <Heatmap {...props} sourceType={sourceType} fetchHeatmapData={fetchHeatmapData} />
    </div>
  );
};

HeatmapModule.propTypes = {
  params: PropTypes.object,
  useSecondaryCategories: PropTypes.bool
};

export default HeatmapModule;
